var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "17px",
    viewBox: "0 0 15 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign-in",
    transform: "translate(-573.000000, -709.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(553.000000, 630.660000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(20.706667, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apple",
    transform: "translate(0.000000, 2.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.35171875,16 C1.9704375,15.9862812 0.0006875,11.1252812 0.0006875,8.6496875 C0.0006875,4.6058125 3.03428125,3.7205 4.20340625,3.7205 C4.73028125,3.7205 5.292875,3.92740625 5.78909375,4.1105 C6.13609375,4.23821875 6.49496875,4.3700625 6.6945625,4.3700625 C6.81403125,4.3700625 7.0955625,4.25790625 7.344125,4.1595 C7.87421875,3.94846875 8.53384375,3.6861875 9.30196875,3.6861875 C9.30334375,3.6861875 9.3051875,3.6861875 9.30653125,3.6861875 C9.88009375,3.6861875 11.6191562,3.8120625 12.6646875,5.3821875 L12.9095937,5.75021875 L12.557125,6.0161875 C12.0535937,6.396125 11.1348437,7.0891875 11.1348437,8.46203125 C11.1348437,10.088 12.1753437,10.7133125 12.6752187,11.0140625 C12.895875,11.1468125 13.1242812,11.2836875 13.1242812,11.5830625 C13.1242812,11.7785312 11.5642187,15.97575 9.29875,15.97575 C8.74440625,15.97575 8.3525625,15.809125 8.0069375,15.6621875 C7.65721875,15.5134062 7.35553125,15.38525 6.85703125,15.38525 C6.60434375,15.38525 6.2848125,15.5047187 5.94653125,15.6315313 C5.48425,15.8040625 4.961,16 4.36728125,16 L4.35171875,16 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54196875,0 C9.60096875,2.127375 8.0795625,3.60325 6.5599375,3.5106875 C6.30953125,1.81296875 8.079375,0 9.54196875,0 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApple);
export default __webpack_public_path__ + "static/media/ic_apple.24b4467f.svg";
export { ForwardRef as ReactComponent };